export default __webpack_public_path__ + "static/media/Rubik-SemiBoldItalic.602e4371.ttf";